module.exports = __webpack_public_path__ + "assets/img/role_menpai_name-a4794927.png";